module.exports = __webpack_public_path__ + "img/logo_2026.3eafaa2e.svg";